// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {AfterViewInit, Component, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import "rxjs/Rx";
import {Location} from "@angular/common";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {LayoutService} from "../../../../recursos/servicio/layout.service";
import {Emisor} from "../recursos/modelo/emisor";
import {Usuario} from "../../usuario/recursos/modelo/usuario";
import {Aplicaciones} from "../recursos/modelo/Aplicaciones";
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";
import {isNullOrUndefined} from "util";
import {PdfDocumentTemplate} from "../recursos/modelo/PdfDocumentTemplate";
import {Certificado} from "../recursos/modelo/certificado";
import {Observable} from "rxjs";
import {MenuSelectorColor} from "../recursos/modelo/MenuSelectorColor";
import {MenuBackColor} from "../recursos/modelo/MenuBackColor";

declare const $: any;
declare var swal: any;


interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

@Component({
    moduleId: module.id,
    selector: 'cmp-form-emisor',
    templateUrl: './view/form-emisor.component.html',
    styleUrls: ['./css/form-emisor.component.scss'],
    providers: [ConsumerService]
})
export class FormEmisorComponent implements OnInit, OnChanges, AfterViewInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    CONST_ORIGEN_LDAP: string;
// mantener el historial de todo las emisores
    tabs = {
        principal: true,
        componentes: false,
        pse: false,
        personalizacion: false,
        emisor: false,
        aplicativo: false,
        adicional: false
    };
    tipoEmisors: any[];
    departamentos: any[];
    cargos: any[];
    roles: any[];
    empresaSelected: any;
    // ITEM DEL CRUD
    // variables de pantalla
    origenCRUD = "Emisor";
    accion = "";
    loading = false;
    loadingCombos = false;
    disabled = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_CUSTOMER_LISTAR: false,
        ROLE_CUSTOMER_CONSULTAR: false,
        ROLE_CUSTOMER_REGISTRAR: false,
        ROLE_CUSTOMER_MODIFICAR: false,
        ROLE_CUSTOMER_ELIMINAR: false,
        ROLE_CUSTOMER_ACTIVAR: false,
        ROLE_CUSTOMER_PERFIL: false
    };

    URL_BACKEND = "";
    portalCliente = "";
    // variables de validaciones del formulario
    form: FormGroup;
    formSearch: FormGroup;
    vdl_ubigeo: FormControl;
    vdl_nombre: FormControl;
    vdl_ruc: FormControl;
    vdl_condicionDomicilio: FormControl;
    vdl_tipoVia: FormControl;
    vdl_nombreVia: FormControl;
    vdl_numero: FormControl;
    vdl_interior: FormControl;
    vdl_distrito: FormControl;
    vdl_provincia: FormControl;
    vdl_dailySummaryRows: FormControl;
    vdl_tipoZona: FormControl;
    vdl_codigoZona: FormControl;
    vdl_departamento: FormControl;
    searchAffiliateControl: FormControl;
    tipoPatalla;
    nameFile: string;
    usuarioSession: Usuario;
    //variables modelo
    ItemSelected = new Emisor();
    transformaciones: any = [];
    integrationTypes: any = [];
    listCloudServiceID: any = [];
    pdfDocumentTemplates: any = [];
    empresaAdmin = false;
    pendienteDatosPrincipales: boolean = false;
    pendienteTranformador: boolean = false;
    loadingAffiliatesShow: boolean = false;
    affiliatesShow: Emisor[] = [];
    filteredAffiliatesShow: Observable<Emisor[]>;
    tipoEmisor: string[];
    search: string;
    @ViewChildren("activoEmisor") check: ElementRef;
    file: any;

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private jwtUtil: UtilConfig,
                private _location: Location,
                private layoutService: LayoutService) {

        this.ItemSelected.logEstatusRegistro = "ACTIVO";
        this.ItemSelected.enableGetStatusCDR = true;
        this.ItemSelected.enabledCOS = false;
        this.ItemSelected.enabledMailjet = false;
        this.ItemSelected.enableSendMailCDR = false;

        // VERIFICA LOS PERMISOS DEL EMISOR LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.usuarioSession = jwtUtil.getCurrentUser();
        let empresa = this.usuarioSession.customer.id;
        if (empresa.toString() == this.jwtUtil.ESCON_CUSTOMER.toString()) {
            this.empresaAdmin = true;
        }

        this.tipoEmisors = [];
        this.tipoEmisors.push({label: 'Seleccione una tipo de emisor * ', value: null});
        this.transformaciones = [];
        //this.transformaciones.push({label:'Seleccione una tipo de transformación * ', value:null});

        this.URL_BACKEND = this.jwtUtil.URL_WS_BACKEND;
        this.portalCliente = "/#";

        this.tipoEmisor = [];
        this.tipoEmisor.push("GENERAL");
        this.tipoEmisor.push("CANAL");
        this.tipoEmisor.push("MULTI_EMPRESA");

    }

    poseePSE(customer) {
        let posee = false;
        $.each(customer.applications, (pos, item) => {
            if (Aplicaciones.TRANSFORMADOR == item)
                posee = true;
        });
        return posee;
    }

    poseeEmisor(customer) {
        let posee = false;
        $.each(customer.applications, (pos, item) => {
            if (Aplicaciones.EMISOR == item)
                posee = true;
        });
        return posee;
    }

    subirFotoLogo($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = (e: FileReaderEvent) => {
                this.ItemSelected.logo = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    ngOnInit() {
        this.consultarCombos();
        this.route.url.subscribe(value => {
            if (value[0].toString() == "perfilCustomer") {
                this.tipoPatalla = "perfilCustomer";
                this.accion = "Modificar";
                this.realizarConsultaEmisor(this.usuarioSession.customer.id);
            } else if (value.length > 0) {
                this.tipoPatalla = "crud";
                this.route.params.subscribe(params => {
                    if (params['id']) {
                        this.realizarConsultaEmisor(params['id']);
                        this.accion = "Modificar";
                    } else {
                        this.ItemSelected.pdfDocumentTemplate.id = 5;
                        this.accion = "Crear";
                    }
                });
            }

        });

        this.createFormControls();
        this.createForm();

        /*this.filteredAffiliatesShow = this.searchAffiliateControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filterAffilate(value))
            );
        */
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    ngAfterViewInit() {


        /* $(window).resize(() => {
            $('.wizard-card').each(function () {

                const $wizard = $(this);
                const index = $wizard.bootstrapWizard('currentIndex');
                let $total = $wizard.find('.nav li').length;
                let $li_width = 100 / $total;

                let total_steps = $wizard.find('.nav li').length;
                let move_distance = $wizard.width() / total_steps;
                let index_temp = index;
                let vertical_level = 0;

                let mobile_device = $(document).width() < 600 && $total > 3;

                if (mobile_device) {
                    move_distance = $wizard.width() / 2;
                    index_temp = index % 2;
                    $li_width = 50;
                }

                $wizard.find('.nav li').css('width', $li_width + '%');

                let step_width = move_distance;
                move_distance = move_distance * index_temp;

                let $current = index + 1;

                if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
                    move_distance -= 8;
                } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
                    move_distance += 8;
                }

                if (mobile_device) {
                    let x: any = index / 2;
                    vertical_level = parseInt(x);
                    vertical_level = vertical_level * 38;
                }

                $wizard.find('.moving-tab').css('width', step_width);
                $('.moving-tab').css({
                    'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
                    'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
                });

                $('.moving-tab').css({
                    'transition': 'transform 0s'
                });
            });
        }); */
    }

    AutorizarActualizacion() {
        if (this.validarObligatorios()) {
            this.pendienteTranformador = false;
            this.pendienteDatosPrincipales = false;
            swal({
                title: '¿Está seguro que desea ' + this.accion + ' el emisor? ',
                text: this.ItemSelected.nombre + " con RUC: " + this.ItemSelected.ruc,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, ' + this.accion + '!'
            }).then(() => {
                this.loading = true;
                this.actualizar();
            }, function (dismiss) {
                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                if (dismiss === 'cancel') {
                }
            })
        }
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴

    validarObligatorios() {
        let validoDP = true;
        let validoPSE = true;
        let li = "";
        if (isNullOrUndefined(this.ItemSelected.ruc) || this.ItemSelected.ruc == "") {
            li += '<li>Debe ingresar un ruc valido para el emisor. en la pestaña "DATOS PRINCIPALES"</li>';
            validoDP = false;
            this.pendienteDatosPrincipales = true;
        }

        if ((isNullOrUndefined(this.ItemSelected.responseType) || this.ItemSelected.responseType == "")) {
            li += '<li>Debe seleccionar un formato de respuesta. en la pestaña "DATOS PRINCIPALES"</li>';
            validoPSE = false;
            this.pendienteDatosPrincipales = true;
        }


        if (this.isPSE() && this.ItemSelected.ownCertificate &&
            (isNullOrUndefined(this.ItemSelected.certificateTO.serialNumber) || this.ItemSelected.certificateTO.serialNumber == "")) {
            li += '<li>Debe cargar un certificado. en la pestaña "TRANSFORMADOR"</li>';
            validoPSE = false;
            this.pendienteTranformador = true;
        }

        if (this.isPSE() && this.ItemSelected.ownCertificate &&
            (isNullOrUndefined(this.ItemSelected.certificatePassword) || this.ItemSelected.certificatePassword == "")) {
            li += '<li>Debe ingresar clave del certificado ingresado. en la pestaña "TRANSFORMADOR"</li>';
            validoPSE = false;
            this.pendienteTranformador = true;
        }


        if (this.isPSE() && (isNullOrUndefined(this.ItemSelected.integrationType) || this.ItemSelected.integrationType == "")) {
            li += '<li>Debe seleccionar un método de integración con PSE. en la pestaña "TRANSFORMADOR"</li>';
            validoPSE = false;
            this.pendienteTranformador = true;
        }

        if (this.isPSE() &&
            (isNullOrUndefined(this.ItemSelected.parserType) || isNullOrUndefined(this.ItemSelected.parserType.id))) {
            li += '<li>Debe seleccionar un método de transformación con PSE. en la pestaña "TRANSFORMADOR"</li>';
            validoPSE = false;
            this.pendienteTranformador = true;
        }

        if (!validoDP || !validoPSE) {
            swal({
                title: "El formulario no se encuentra válido",
                width: 800,
                html: '<p style="padding-left: 17px !important;"><b>Verificar las siguientes opciones:</b></p>' +
                    '<ol style="text-align: left">' +
                    li +
                    '</ol>',
                type: 'error'
            });
        }

        if (validoDP)
            this.pendienteDatosPrincipales = false;

        if (validoPSE)
            this.pendienteTranformador = false;

        return validoDP && validoPSE;
    }

    createFormControls() {
        this.vdl_ruc = new FormControl({value: "", disabled: (this.accion == 'Modificar')}, [
            Validators.required
        ]);
        this.vdl_nombre = new FormControl({value: "", disabled: this.disabled}, [
            Validators.required
        ]);

        this.vdl_condicionDomicilio = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);
        this.vdl_ubigeo = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);
        this.vdl_tipoVia = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

        this.vdl_nombreVia = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);
        this.vdl_codigoZona = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

        this.vdl_tipoZona = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

        this.vdl_numero = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

        this.vdl_interior = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

        this.vdl_provincia = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

        this.vdl_distrito = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);
        this.vdl_dailySummaryRows = new FormControl({value: 0, disabled: this.disabled}, [
            Validators.required
        ]);

        this.vdl_departamento = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);
        this.searchAffiliateControl = new FormControl({value: "", disabled: this.disabled}, [
            Validators.nullValidator
        ]);

    }

    createForm() {
        this.form = this.fb.group({
            "condicionDomicilio": this.vdl_condicionDomicilio,
            "ruc": this.vdl_ruc,
            "nombre": this.vdl_nombre,
            "ubigeo": this.vdl_ubigeo,
            "nombreVia": this.vdl_nombreVia,
            "codigoZona": this.vdl_codigoZona,
            "numero": this.vdl_numero,
            "interior": this.vdl_interior,
            "distrito": this.vdl_distrito,
            "provincia": this.vdl_provincia,
            "dailySummaryRows": this.vdl_dailySummaryRows,
            "tipoZona": this.vdl_tipoZona,
            "tipoVia": this.vdl_tipoVia,
            "departamento": this.vdl_departamento
        });
        /*this.formSearch = this.fb.group({
            "search": this.searchAffiliateControl
        });*/

    }

    help() {
        $.getScript("./assets/js/core/material-google.js", function () {
            setTimeout(function () {
                eval("$('#helpActualizar').tapTarget('open');")
            }, 700);
            setTimeout(function () {
                eval("$('#helpActualizar').tapTarget('close');")
            }, 5000);

            setTimeout(function () {
                eval("$('#helpRegresar').tapTarget('open');")
            }, 5100);
            setTimeout(function () {
                eval("$('#helpRegresar').tapTarget('close');")
            }, 9000);

            setTimeout(function () {
                eval("$('#helpFoto').tapTarget('open');")
            }, 9100);
            setTimeout(function () {
                eval("$('#helpFoto').tapTarget('close');")
            }, 12000);

        });
    }

    mostrarOpciones() {
        $("ul#slide-out").addClass("open");
        $("i.cerrarAleta").addClass("open");
        if (this.affiliatesShow.length < 1) {
            this.loadingAffiliatesShow = true;
            this.consumer.search("", null, WebServices.URL_LIST_EMISOR)
                .subscribe(result => {
                    this.affiliatesShow = result["customers"];
                    this.loadingAffiliatesShow = false;
                }, err => {
                    this.loadingAffiliatesShow = false;
                    this.affiliatesShow = [];
                    this.loading = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo obtener la lista de los emisores", this.router)
                });
        }
    }

    cargando(valor) {
        this.loading = valor;
    }

    backClicked() {
        this._location.back();
    }

    public verificarRuc() {
        if (this.ItemSelected.ruc != "") {
            // LLAMADO AL SERVICIO
            this.loading = true;
            this.consumer.post(WebServices.URL_VERIFICAR_MASTER_EMISOR, {customer: {ruc: this.ItemSelected.ruc}})
                .subscribe(result => {

                    $("#componentes_li").focus();
                    //DEFAULT DATA
                    this.ItemSelected = result["customer"];
                    this.ItemSelected.applications = [];
                    this.ItemSelected.applications.push(Aplicaciones.VALIDADOR);
                    this.ItemSelected.applications.push(Aplicaciones.ADMINISTRADOR);
                    this.ItemSelected.applications.push(Aplicaciones.TRANSFORMADOR);

                    this.ItemSelected.pdfDocumentTemplate = new PdfDocumentTemplate(5);
                    this.ItemSelected.menuBackgroundType = "IMAGE";
                    this.ItemSelected.logEstatusRegistro = "ACTIVO";
                    this.ItemSelected.ownCertificate = false;
                    this.ItemSelected.certificateTO = new Certificado();
                    this.ItemSelected.pdfCustomFooter = result["footerCustomText"];

                    this.ItemSelected.emailAttachments = true;

                    //APLICATIVO
                    this.ItemSelected.menuSelectorColor = MenuSelectorColor.BLANCO;
                    this.ItemSelected.menuBackColor = MenuBackColor.OSCURO;
                    this.ItemSelected.menuBackgroundImage = 0;


                    this.ItemSelected.id = null;
                    this.disabled = false;
                    this.loading = false;

                }, err => {
                    this.loading = false;
                    swal({
                        title: "No se pudo consultar al emisor",
                        text: err,
                        type: "error"
                    });
                });
        }
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 

    consultarCombos() {
        // LLAMADO AL SERVICIO
        this.loadingCombos = true;
        this.consumer.post(WebServices.URL_GET_COMBOS_EMISOR)
            .subscribe(result => {

                $.each(result["cloudServiceIDList"], (pos, item) => {
                    this.listCloudServiceID.push({label: item, value: item});
                });
                $.each(result["comboRequestTypes"], (pos, item) => {
                    this.integrationTypes.push({label: item, value: item});
                });
                $.each(result["comboPdfDocumentTemplates"], (pos, item) => {
                    this.pdfDocumentTemplates.push(item);
                });

                $.each(result["comboParserTypes"], (pos, item) => {
                    this.transformaciones.push({label: item.identifier, value: item});
                });

                this.loadingCombos = false;
            }, err => {
                this.loadingCombos = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar los combos", this.router)
            });
    }

    actualizar() {
        // LLAMADO AL SERVICIO
        if (this.ItemSelected.enableGetStatusCDR == undefined) {
            this.ItemSelected.enableGetStatusCDR = false;
        }

        if (!this.ItemSelected.enabledCOS) {
            this.ItemSelected.cloudServiceID = 'LOCAL';
        }

        this.ItemSelected.parserTypeId = this.ItemSelected.parserType.id;

        this.consumer.create(WebServices.URL_ACTUALIZAR__EMISOR, {customer: this.ItemSelected})
            .subscribe(result => {
                swal(
                    'Actualizado!',
                    '',
                    'success'
                );

                if (this.tipoPatalla == "perfilCustomer") {
                    this.usuarioSession.customer.nombre = this.ItemSelected.nombre;
                    this.usuarioSession.customer.ruc = this.ItemSelected.ruc;
                    this.usuarioSession.customer.logo = this.ItemSelected.logo;
                    this.usuarioSession.customer.igv = this.ItemSelected.igv;
                    this.usuarioSession.customer.amountWithIGV = this.ItemSelected.amountWithIGV;
                    this.jwtUtil.setCurrentUser(this.usuarioSession);
                    this.layoutService.actualizarSession();
                    //this.router.navigate(['/content', {outlets: {'second': ['perfilCustomer']}}]);
                } else {
                    //this.router.navigate(['/content', {outlets: {'second': ['emisor']}}]);
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo actualizar el emisor", this.router)
            });
    }

    deshabilitarBoton(): boolean {
        //return !this.form.valid;
        return false;
    }

    toggleEstado() {
        if (this.ItemSelected.logEstatusRegistro == 'ACTIVO') {
            this.ItemSelected.logEstatusRegistro = 'INACTIVO';
        } else {
            this.ItemSelected.logEstatusRegistro = 'ACTIVO';
        }
    }

    toggleSaledRecord() {
        this.ItemSelected.salesRecord = !this.ItemSelected.salesRecord;
    }
toggleEnabledHistory() {
        this.ItemSelected.enabledHistory = !this.ItemSelected.enabledHistory;
    }

    toggleDailySummary() {
        this.ItemSelected.dailySummary = !this.ItemSelected.dailySummary;
        this.ItemSelected.dailySummaryRows = 0;
    }

    isPSE() {
        let pse = false;
        $.each(this.ItemSelected.applications, (pos, item) => {
            if (item == Aplicaciones.TRANSFORMADOR)
                pse = true;
        });
        return pse;
    }

    verTab(tab: string) {
        this.tabs.principal = false;
        this.tabs.componentes = false;
        this.tabs.pse = false;
        this.tabs.personalizacion = false;
        this.tabs.emisor = false;
        this.tabs.aplicativo = false;
        this.tabs.adicional = false;

        this.tabs[tab] = true;
    }

    eliminarAfiliado(i) {
        swal({
            title: '¿Eliminar emisor del ' + this.ItemSelected.type,
            text: "¿Está seguro que desea eliminar empresa del grupo? ",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, ' + this.accion + '!'
        }).then(() => {
            this.ItemSelected.affiliates.splice(i, 1);
            swal(
                'Actualizado!',
                'Esto se vera reflejado al guardar el emisor',
                'success'
            );
        }, function (dismiss) {
            if (dismiss === 'cancel') {
            }
        })

    }

    agregarCandidato(candidato, i) {
        if (this.ItemSelected.affiliates == null)
            this.ItemSelected.affiliates = [];

        this.ItemSelected.affiliates.push(candidato);
        this.affiliatesShow.splice(i, 1);
    }

    cerrarDetalle() {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
    };

    private _filterAffilate(value: string): Emisor[] {
        let filterValue = "";

        if (value != null)
            filterValue = value.toLowerCase();
        let aux = this.affiliatesShow.filter(option => ((option.nombre.toLowerCase().includes(filterValue)) || (option.ruc.toLowerCase().includes(filterValue))));
        return aux;
    }

    private realizarConsultaEmisor(id) {
        // LLAMADO AL SERVICIO
        this.loading = true;
        this.consumer.getById("customer", id, WebServices.URL_GET_EMISOR)
            .subscribe(result => {
                this.ItemSelected = result["customer"];

                if (isNullOrUndefined(this.ItemSelected.applications) || this.ItemSelected.applications.length == 0) {
                    this.ItemSelected.applications = [];
                    this.ItemSelected.applications.push(Aplicaciones.VALIDADOR);
                    this.ItemSelected.applications.push(Aplicaciones.ADMINISTRADOR);
                }

                if (!this.ItemSelected.certificateTO)
                    this.ItemSelected.certificateTO = new Certificado();

                if (this.poseePSE(this.ItemSelected))
                    this.ItemSelected.posee_PSE = true;
                else
                    this.ItemSelected.posee_PSE = false;

                if (this.poseeEmisor(this.ItemSelected))
                    this.ItemSelected.posee_EMISOR = true;
                else
                    this.ItemSelected.posee_EMISOR = false;

                $.each(this.ItemSelected.receiverList, (pos, item) => {
                    delete item["authorities"];
                    delete item["enabled"];
                });

                this.portalCliente = this.ItemSelected.clientPortalToken;
                this.loading = false;
            }, err => {
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar al emisor", this.router)
            });
    }

}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-form-emisor/form-emisor.component.ts